import { redirect } from 'react-router'
import { AuthenticationError } from '#features/User/AuthenticationError'
import { userManager } from '#features/User/userManager'

export interface AuthRouteLoaderData {
  error?: AuthenticationError
}

export const authRouteLoader = async () => {
  try {
    const user = await userManager.signinCallback()
    if (!user) {
      return {
        error: new AuthenticationError('User not found after sign-in callback'),
      }
    }

    return redirect(user.url_state ?? '/')
  } catch (error) {
    console.error('Error during sign-in callback:', error)
    return {
      error: new AuthenticationError('Failed to complete sign-in callback', error),
    }
  }
}
